import { mifuncion } from './modules/test';
import '../sass/main.scss';

//components
import { getChildsSwiper } from './components/Swiper';
import { getChildsAccordeon } from './components/Accordeon';
import { getChildsAos } from './components/Aos';

window.addEventListener('load', () => {
	getChildsAos();
	getChildsSwiper();
	getChildsAccordeon();
	mifuncion();
});
